import { jsx as _jsx } from "react/jsx-runtime";
import { HiChevronLeft } from "react-icons/hi2";
import cn from "classnames";
const SwiperButton = ({ isNext, className, swiper }) => {
    return (_jsx("button", { "aria-label": isNext ? "next" : "previous", className: cn(className), onClick: swiper ? () => (isNext ? swiper.slideNext() : swiper.slidePrev()) : null, children: _jsx(HiChevronLeft, { className: cn("swiper-btn", isNext && "swiper-btn--next") }) }));
};
export default SwiperButton;
